


export const addRows = (nRows,currentFormControls, headers) => {
    // formControls is and array of objects then is passed by reference
    const currentIndex = currentFormControls.slice(-1)[0][0].index;
    let newIndex = currentIndex + 1;
    for (let row = 0; row < nRows; row++){
        let newRow = [];
        for (let i = 0; i < headers.length; i++) {
            const header = headers[i];
            let newItem = { id:header.id, index:newIndex, error:''};
            if (header.inputType === "selectMultiple"){
                newItem["value"] = [];
            } else {
                newItem["value"] = '';
            }
            newRow.push(newItem);
        }
        // Push new row to formControls
        currentFormControls.push(newRow)
        newIndex = newIndex + 1;
    }
}

export const resetFormControls = (formControls, headers) => {
    // Reset all values
    let currentFormControls = [...formControls];
    // Loop Form Controls to clean all values
    for (let row of currentFormControls){
        for (let column of headers){
            let field = row.find(item => item.id === column.id);
            if (Array.isArray(field.value)) field.value = [];
            else field.value = "";
            field.error = "";
            // Special case ValueIndex in ReactSelected*
            if ("valueIndex" in field) field.valueIndex = null;
        }
    }
    return currentFormControls;
}

export const checkRowFilled = (row, headers) => {
    //Check if row is filled
    let nColumn = 0;
    for (let column of row){
        const type = headers[nColumn].inputType;
        const value = column.value;

        switch (type) {
          case "text":
          case "textReadOnly":
          case "number":
              if (value !== "") return true;
              break;
          case "select":
          case "select-experiment":
          case "select-participant":
              if (value !== "----" && value !== "") return true;
              break;
          case "selectMultiple":
              if (value.length === 1)
              {
                  if (value[0] !== "----") return true;
              }
              else if (value.length > 1)
              {
                  return true;
              }
              break;
        }
        nColumn = nColumn + 1;
    }
    return false;
} 

export const hasErrors = formControls => {
    /*Checks if formControls has some type of Error*/
    for (let row of formControls) {
        for(let col of row) {
            if (col.error !== "") return true;
        }
    }
    return false;
}

export const getFilledRows = (currentFormControls, headers) => {
    //Extract the rows that are filled from the form
    return currentFormControls.filter((row) => checkRowFilled(row, headers));
}

export const getNumbersErrors = formControls => {
    // check for errors on form contols
    let nErrors = 0;
    formControls.forEach((row) => {
        row.forEach((field) => {
            if(field.error!== "") nErrors = nErrors+1;
        });
    });
    return nErrors
}


